export enum fieldType {
	'text',
	'select', //autocomplete
	'selectBox',
	'radio',
	'datePicker',
	'textArea',
	'dateRangePicker',
}

// for select use options

export interface Ioption {
	value: string;
	label: string;
	disabled?: boolean;
}

export interface IfieldProps {
	name: string;
	value?: string | number | null;
	defaultValue?: string | number;
	options?: Array<Ioption> | string;
	error?: boolean;
	helperText?: string;
	placeholder?: string;
	label?: string;
	required?: boolean;
	handleChange?: any;
	handleValidation?: any;
	disabled?: boolean;
	type?: string;
	autoselect?: string;
	sx?: any;
	regex?: any;
}

export enum validationTypes {
	requierd = 'requierd',
	duplicatefields = 'duplicate',
	email = 'email',
	phone = 'phone',
	match = 'match',
	lettersOnly = 'lettersOnly',
	id = 'id',
	balance = 'balance',
}
export enum fieldsGroupType {
	row = 'row',
	col = 'column',
}
export interface IfieldsGroup {
	type: fieldsGroupType;
	styleObj?: object;
	spacing?: number;
	fields: Ifield[];
}

export interface Ifield {
	type: fieldType;
	props: IfieldProps;
	validation?: validationTypes[];
	styleObj?: object;
	valueProperty?: string;
	labelProperty?: string;
	renderOption?: any;
	renderInput?: any;
	getOptionDisabled?: any;
	maxValue?: number;
	months?: number;
}

export interface IcreateFormProps {
	initialValidation?: { [key: string]: validationProps };
	name: string;
	handleChange: any;
	fieldsGroups: IfieldsGroup[];
	validations?: { [key: string]: validationTypes[] };
}

export type validationProps = {
	name: string;
	valid: boolean;
	errorText: string;
};

export type invalidFields = { [key: string]: validationProps };
